import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

export const Button = styled(animated.button)<{ $isActive: boolean }>`
    ${({ theme, $isActive }) => css`
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        border: 0.0625rem solid ${theme.colors.tertiary.hex};
        background: transparent;
        display: block;
        cursor: pointer;
        padding: 0; /* fixes issue stretched indicator on iphone safari */

        ${$isActive &&
        css`
            background: ${theme.colors.tertiary.hex};
        `}
    `}
`;
